import {getSelectedDeliveryCountry} from '../../../selectors/selectors';
import * as types from '../../action-types';

const initialiseBillingAddressByPaymentOptionType = (paymentOptionType, country) => ({
  type: types.INITIALISE_BILLING_ADDRESS_BY_PAYMENT_OPTION_TYPE,
  paymentOptionType,
  country,
});

export default paymentOptionType => (dispatch, getState) => {
  if (paymentOptionType) {
    dispatch(initialiseBillingAddressByPaymentOptionType(paymentOptionType, getSelectedDeliveryCountry(getState())));
  }
};
